import { LogActionResponse, UserPublicProfile } from '@features/public-profile/utils/models/public-profile.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const PublicProfileActions = createActionGroup({
  source: 'Public Profile Page',
  events: {
    /** get public profile */
    'Get Public Profile': props<{ slug: string }>(),
    'Get Public Profile Success': props<{ profile: UserPublicProfile }>(),
    'Get Public Profile Failure': props<{ error: HttpError }>(),
    /** log action */
    'Log Action': props<{ actionId: number; userId: number }>(),
    'Log Action Success': props<{ data: LogActionResponse }>(),
    'Log Action Failure': props<{ error: HttpError }>(),
  },
});

export const PublicProfileResetActions = createActionGroup({
  source: 'Public Profile Page',
  events: {
    'Cancel Public Profile Actions': emptyProps(),
    'Cancel Public Profile Actions Success': emptyProps(),
    'Reset Public Profile': emptyProps(),
  },
});
